'use strict';

/*
 * Adjusts navigation menu width to the length of the broadest menu. 
 */

class AdjustMenuWidth {

    // instantiate object
    constructor() {
        this.primNav = document.querySelector('.prim-navigation');
        this.maxWidth = parseInt( window.getComputedStyle(this.primNav).getPropertyValue("width") );
    
        this.devNav = document.querySelector('.dev-navigation');
        this.devNavWidth = parseInt( window.getComputedStyle(this.devNav).getPropertyValue("width") );
    
        this.projNav = document.querySelector('.proj-navigation');
        this.projNavWidth = parseInt( window.getComputedStyle(this.projNav).getPropertyValue("width") );

        //this.events();
        this.adjustMenuWidth();
    }

    // event listeners
    events() {
    }

    // methods
    adjustMenuWidth() {
    
        // let maxWidth be the largest ...
        if (this.devNavWidth > this.maxWidth) this.maxWidth = this.devNavWidth;
        if (this.projNavWidth > this.maxWidth) this.maxWidth = this.projNavWidth;
    
        // ... and set all widths to this largest value
        this.primNav.style.width = `${this.maxWidth}px`;
        this.devNav.style.width = `${this.maxWidth}px`;
        this.projNav.style.width = `${this.maxWidth}px`
    
        // hide all menus that do not have at least one child with class 'nav-menu--active'
        if ( ! this.is_active_menu(this.devNav) ) {
            this.devNav.classList.add('navigation--invisible');
        }
    
        if ( ! this.is_active_menu(this.projNav) ) {
            this.projNav.classList.add('navigation--invisible');
        }
            
    }
    
    is_active_menu(menu) {
        const children = menu.children;
        
        for(let child of children) {
            if ( child.classList.contains('nav-entry--active') )
                return true;
        }
    
        return false;
    }
}

export default AdjustMenuWidth;